import { CloseOutlined } from '@ant-design/icons';
import { CloseCircleIcon, CloseIcon } from '@mm/icons';
import { hideSlideoutMenu } from '@mm/state/actions/viewActions';
import { StoreState } from '@mm/state/store-interfaces';
import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import './SlideoutHeader.scss';

type Props = {
  children: React.ReactNode;
  hideSlideoutMenu: () => {};
  onClose?: () => void;
  className?: string;
  closeIcon?: 'closeCircle' | 'close' | 'outlinedClose';
  closeIconClassName?: string;
};

const SlideoutHeaderPure = ({
  children,
  hideSlideoutMenu,
  onClose = () => {},
  className,
  closeIcon = 'closeCircle',
  closeIconClassName,
}: Props) => (
  <div className={classNames('slideout-header', className)}>
    <div className="slideout-header__items">{children}</div>
    <div
      className={classNames(
        'slideout-header__item slideout-header__close-item-wrapper',
        closeIconClassName,
      )}
    >
      <span
        className="slideout-header__close-item"
        onClick={() => {
          hideSlideoutMenu();
          if (onClose) {
            onClose();
          }
        }}
      >
        {closeIcon === 'closeCircle' && <CloseCircleIcon />}
        {closeIcon === 'outlinedClose' && <CloseOutlined />}
        {closeIcon === 'close' && <CloseIcon color="#8c8c8c" />}
      </span>
    </div>
  </div>
);

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  hideSlideoutMenu: () => dispatch(hideSlideoutMenu()),
});

export const SlideoutHeader = connect(
  null,
  mapDispatchToProps,
)(SlideoutHeaderPure);
